var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrashIconOutlined(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M456 80C469.3 80 480 90.75 480 104C480 117.3 469.3 128 456 128H444.4L420.4 452.7C417.9 486.1 390.1 512 356.6 512H155.4C121.92 512 94.09 486.1 91.61 452.7L67.56 128H56C42.75 128 32 117.3 32 104C32 90.75 42.75 80 56 80H125.82L162.5 24.94C172.9 9.357 190.4 0 209.1 0H302.9C321.6 0 339.1 9.358 349.5 24.94L386.2 80H456ZM209.1 48C206.5 48 203.1 49.34 202.5 51.56L183.5 80H328.5L309.5 51.56C308 49.34 305.5 48 302.9 48H209.1ZM396.3 128H115.69L139.5 449.2C140.1 457.5 147.1 464 155.4 464H356.6C364.9 464 371.9 457.5 372.5 449.2L396.3 128Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashIconOutlined);
export default __webpack_public_path__ + "static/media/trash-icon-outlined.d3e5ac4978fbc65ea1135ae5a0ee1f75.svg";
export { ForwardRef as ReactComponent };